// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__k8tMq","productName":"Table_productName__4iVZ2"};